export default __webpack_public_path__ + "static/media/logo.d96420c1.svg";